// export const SUCCESS_STATUS = 'success';
// export const ERROR_STATUS = 'error';
// export const LOADING_STATUS = 'loading';

// export default {
//     SUCCESS_STATUS,
//     ERROR_STATUS,
//     LOADING_STATUS,
// };

export const railsTests = {
    WIRE: 'wire',
    ACH: 'ach',
    MONITORING: 'monitoring',
    INSTANT_PAYMENT: 'instant_payment',
    TEST_NAMES: 'technical_test_name_matching',
    GENERAL: 'general',
    TEST_WIRE: 'technical_test_wires_screening',
    TEST_MONITORING: 'technical_test_monitoring'

}